// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__lqm4P","modalFooterButton":"ModalNotes_modalFooterButton__21aOZ"};